import React from 'react';
import { EasyUploadLinkModalContextProvider } from './context/EasyUploadLinkModalContext';
import EasyUploadLinkModal from './nested/modal';
import './styles.scss';
function EasyUploadLinkModalWrapper(params) {
    if (!params.subcontractWorkStatusId)
        return null;
    return (React.createElement(EasyUploadLinkModalContextProvider, { subcontractWorkStatusId: params.subcontractWorkStatusId, onClose: params.onClose },
        React.createElement(EasyUploadLinkModal, null)));
}
export default EasyUploadLinkModalWrapper;
